import type { ProjectContestClassification } from './project-contest-classification.model';
import { ProjectContestClassificationEnum } from './project-contest-classification.model';

/**
 * A user's initial text/description on PJP/Find Page is used
 * as the `id` in the project contest classification datastore
 */
export interface GenerateProjectContestClassificationOptions {
  readonly id: string;
  readonly classification?: ProjectContestClassificationEnum;
}

export function generateProjectContestClassification({
  id,
  classification,
}: GenerateProjectContestClassificationOptions): ProjectContestClassification {
  return {
    id,
    classification:
      classification || ProjectContestClassificationEnum.PROJECT_ONLY,
  };
}
